/**
 * Parse an array to options format for react-select, see: https://react-select.com/home
 * @deprecated prefer use toOptions
 *
 */
export const getValueAndLabel = (resource, value, label) => {
  return resource.map((item) => {
    return Object.assign(
      {},
      { value: item[value], label: item[label], resource: item }
    )
  })
}

/**
 * Converts an array of data into an array of options with labels and values. (overall for react-select)
 *
 * @param {Object} options - Configuration options.
 * @param {Object[]} options.data - The array of data to be converted.
 * @param {string} [options.value = 'id'] options.value - The key in each object of the data array to be used as the value.
 * @param {string} [options.label = 'name'] options.label - The key in each object of the data array to be used as the label.
 * @returns {Array} An array of objects with values and labels generated from the input data.
 *
 * @example
 * // Example 1: Using custom value and label keys
 * const employeeData= [
 *   { id: 1, name: 'Juan', age: 44 },
 *   { id: 2, name: 'Pedro', age: 32 }
 * ];
 *
 * const employeeOptions = toOptions({ data: employeeData });
 * console.log(employeeOptions);
 * // Output: [{ value: 1, label: 'Juan', resource: { id: 1, name: 'Juan', age: 44 } }, { value: 2, label: 'Pedro', resource: { id: 2, name: 'Pedro', age: 32 } }]
 *
 */
export const toOptions = ({ data, value = 'id', label = 'name' }) => {
  return data.map((item) => {
    return Object.assign(
      {},
      { value: item[value], label: item[label], resource: item }
    )
  })
}
export * from './is-a-valid-rut'
export * from './phone'
export * from './yup'
